import axios from 'axios';

export const FETCH = Symbol('fetch action');

export default ({ dispatch }) => (next) => (action) => {
  const fetchConfig = action[FETCH];

  if (fetchConfig === undefined) {
    return next(action);
  }

  delete action[FETCH]; // eslint-disable-line no-param-reassign

  dispatch({ ...action, status: 'start' });

  const { method = 'GET', data, nullData = false, success, fail, ...restConfig } = fetchConfig;

  const config = {
    method,
    ...restConfig,
  };
  if (!nullData) {
    config.data = data || {};
  }
  // console.log('config = ', config);
  return axios.request(config)
    .then((response) => {
      success && success(response.data);
      return next({
        ...action,
        data: response,
        status: 'done',
      });
    })
    .catch((error) => {
      fail && fail(error);
      return next({
        ...action,
        error: error.response,
        status: 'error',
      });
    });
};
